import { Flex } from "@radix-ui/themes";
import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { useLDClient } from "@launchdarkly/react-sdk";
import { IrisCtaLink } from "../../components/IrisCtaLink";
import { PillLink } from "../../components/PillLink";

const TITLE = "Iris";
const DESCRIPTION =
  "Iris is your non-clinical therapy companion, available 24/7 on iMessage. Experience support that feels like a breeze.";
const CANONICAL = "https://irischat.ai";

export function HomePage() {
  // useLDClient throws during prerendering when LDProvider context doesn't exist
  const ldClient = typeof window !== "undefined" ? useLDClient() : undefined;
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 140);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
        <meta name="description" content={DESCRIPTION} />
        <link rel="canonical" href={CANONICAL} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={CANONICAL} />
        <meta property="og:title" content={TITLE} />
        <meta property="og:description" content={DESCRIPTION} />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content={TITLE} />
        <meta name="twitter:description" content={DESCRIPTION} />
      </Helmet>
      <Flex
        className="content"
        direction="column"
        align="start"
        justify="end"
        style={{
          height: "calc(100dvh - 160px)", // header + padding
        }}
      >
        <div
          className={`copy hero-copy-reveal${isVisible ? " is-visible" : ""}`}
        >
          <h1>ai for your mind.</h1>
          <h2>
            here to talk, reflect,
            <br />
            and grow with you.
          </h2>

          <div className="hero-actions">
            <IrisCtaLink overridePhone={import.meta.env.VITE_PUBLIC_IRIS_HOME_PAGE_PHONE_NUMBER} className="cta" ldClient={ldClient ?? undefined} />
            <PillLink href="/learn-more" aria-label="Learn more about Iris">
              Learn More
            </PillLink>
          </div>

          <p className="terms">
            By messaging Iris, you agree with our{" "}
            <a href="/terms-conditions">Terms</a> and{" "}
            <a href="/privacy">Privacy</a>.
          </p>
        </div>
      </Flex>
    </>
  );
}
